import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useFirebase } from 'react-redux-firebase';
import { LOGIN, SIGNUP } from '../constants/routes';
import { useDispatch } from 'react-redux';
import { actions } from '../actions';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="#">
        Prestobots
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100dvh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function LoginSide() {
  const firebase = useFirebase();
  const classes = useStyles();
  const appDispatch = useDispatch();

  const [email, setEmail] = useState('');

  function handleSubmit(event) {
    event.preventDefault();

    firebase
      .resetPassword(email)
      .then(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: `Se envio un email a ${email}. Si no lo encuentra resive su casilla de spam`,
            snackbarSeverity: 'success',
          },
        });
      })
      .catch((error) => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: error.message,
            snackbarSeverity: 'error',
          },
        });
      });
  }

  return (
    <div className="App">
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Recuperar Contraseña
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Enviar Email
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link component={RouterLink} to={LOGIN} variant="body2">
                    Recordaste la contraseña? Ingresa!
                  </Link>
                </Grid>
                <Grid item>
                  <Link component={RouterLink} to={SIGNUP} variant="body2">
                    No tienes una cuenta? Crea una!
                  </Link>
                </Grid>
              </Grid>
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
